import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { missedPayloadsCountService } from 'src/app/services/missedPayloadsCount/missedPayloadsCount.service';

@Component({
    selector: 'app-missedPayloadsCount-card',
    templateUrl: './missedPayloadsCount-card.component.html',
    styleUrls: ['./missedPayloadsCount-card.component.scss'],
})
export class MissedPayloadsCountCardComponent implements OnInit {

    missedPayloadsCount$ = new BehaviorSubject<string | undefined>(undefined);

    constructor(
        private _missedPayloadsCountService: missedPayloadsCountService
    ) {

    }

    ngOnInit() {
        this._missedPayloadsCountService.getTankData$("30","4").subscribe(result => {
            this.missedPayloadsCount$.next(result.scalar);
        });
    }
}
